// extracted by mini-css-extract-plugin
export default {"timeDisplay":"timeDisplay_timeDisplay__itSqA"};